import { Observable } from "rxjs";
import { Service } from "typedi";
import { IConfig } from "../../../../shared/model/config/IConfig";

@Service()
export abstract class IControlFrameInitializationRequest {
  abstract request(config: IConfig): Observable<unknown>;
}
